import NoPostsFeed from '../../components/no-posts-feed';
import NoPostsFeedWriter from '../../components/no-posts-feed-writer';
import forPostWriter from '../../hoc/for-post-writer';

export default forPostWriter(NoPostsFeedWriter, NoPostsFeed);
